import React, { useState } from "react"
import { injectIntl } from "react-intl"
import { withRouter } from "react-router-dom"
import ReactTooltip from "react-tooltip"
import Icon from "../../icon/icon.component"
import FeatureProtectionWrapperMain from "./featureProtectionWrapperMain.component"
import { messages, getMessage, handleClick } from "./helpers.jsx"
import ConnectIntegrationButton from "../../button/connectintegrationbutton.component.jsx"
import { Intl } from "../../../state/helpers/IntlProps"

type OwnProps = {
    isProtected: boolean
    protectionRule: boolean
    protectedClassName: string
    accountFeatureKey: string
    className: string
    type: "button" | "submit" | "reset"
    children: JSX.Element
    to: string
    showLock: boolean
    premium: boolean
    message: string
    integrationKey: string
    callback: () => void
    onClose: () => void
    onClickProtected: () => void
    onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
    intl: Intl
}

const IntegrationButtonWrapper = (props: OwnProps) => {
    const [displayModal, setDisplayModal] = useState(false)
    const showLock = props.showLock ?? true

    const lockedItem = <span key={"tooltip-container-integration-button"} data-tip
        data-for={"integrationLock-integration-button"}>
        <button key={"integration-button"} className={props.protectedClassName || "btn"} onClick={(e) => {
            handleClick(e, props, setDisplayModal)
        }}>
            <ReactTooltip
                place="top"
                className="integrationLock"
                id={"integrationLock-integration-button"}
                type="warning"
                effect="solid"
                multiline={true}>
                {getMessage(props.message, props.intl.formatMessage(messages["update_subscription"]))}
            </ReactTooltip>
            <div className="d-inline-flex">
                {props.children}
                {showLock && <Icon value="lock" className="lock"/>}
            </div>
        </button>
    </span>

    const item = <ConnectIntegrationButton
        key={"integration-button"}
        integrationKey={props.integrationKey}
        url={props.to}
        className={props.className}
        label={props.children}
    />

    return (<>
        <FeatureProtectionWrapperMain
            protectionRule={props.protectionRule}
            accountFeatureKey={props.accountFeatureKey}
            isProtected={props.isProtected ?? true}
            displayModal={displayModal}
            premium={props.premium}
            lockedItem={lockedItem}
            message={props.message}
            item={item}
            callback={props.callback || function () {
                return
            }}
            onClickProtected={props.onClickProtected || function () {
                return
            }}
            onClose={() => {
                setDisplayModal(false)
                if (props.onClose) {
                    props.onClose()
                }
            }}
            onClick={props.onClick || function () {
                return
            }}
        >

        </FeatureProtectionWrapperMain>
    </>)


}

export default withRouter(injectIntl(IntegrationButtonWrapper))


// WEBPACK FOOTER //
// ./src/common/rich-text/feature-protection-wrappers/integrationButtonWrapper.component.tsx